import { createFileRoute } from '@tanstack/react-router';
import { AgentTasks } from '@/components/agent-tasks';
import { AdminTaskAssignment } from '@/components/admin-task-assignment';
import { UnsubmittedReports } from '@/components/unsubmitted-reports';
import { usePermissions } from '@/hooks/use-permissions';
import { PERMISSIONS } from '@property/shared';

export const Route = createFileRoute('/dashboard/tasks/')({
  component: TasksPage,
});

function TasksPage() {
  const { can } = usePermissions();
  return (
    <div className="space-y-8">
      {can(PERMISSIONS.TASKS_ASSIGN) && <AdminTaskAssignment />}
      {can(PERMISSIONS.TASKS_READ) && <UnsubmittedReports />}
      {can(PERMISSIONS.TASKS_READ) && <AgentTasks />}
    </div>
  );
}
